import React from 'react'
import {StyleSheet, View} from 'react-native'
import {Trans} from '@lingui/macro'
import {useNavigation} from '@react-navigation/native'
import {type NativeStackScreenProps} from '@react-navigation/native-stack'

import {type CommonNavigatorParams, type NavigationProp} from '#/lib/routes/types'
import {atoms as a, useTheme} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {Warning_Stroke2_Corner0_Rounded as WarningIcon} from '#/components/icons/Warning'
import * as Layout from '#/components/Layout'
import {Text} from '#/components/Typography'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'PremiumDeclined'>

export function PremiumDeclinedScreen({}: Props) {
  const t = useTheme()
  const navigation = useNavigation<NavigationProp>()

  const handleTryAgain = React.useCallback(() => {
    navigation.navigate('Premium')
  }, [navigation])

  const handleGoHome = React.useCallback(() => {
    navigation.navigate('Home')
  }, [navigation])

  return (
    <Layout.Screen>
      <Layout.Content>
        <View style={[a.flex_1, a.justify_center, a.align_center, a.p_xl, styles.container]}>
          <View style={[styles.iconContainer, {backgroundColor: t.palette.negative_100}]}>
            <WarningIcon size="xl" style={{color: t.palette.negative_600}} />
          </View>

          <Text style={[a.text_2xl, a.font_bold, a.text_center, a.mt_xl, t.atoms.text]}>
            <Trans>Payment Declined</Trans>
          </Text>

          <Text style={[a.text_lg, a.text_center, a.mt_md, t.atoms.text_contrast_medium]}>
            <Trans>Your payment could not be processed. Please try again or use a different payment method.</Trans>
          </Text>

          <Button
            label="Try Again"
            onPress={handleTryAgain}
            size="large"
            variant="solid"
            color="primary"
            style={[a.rounded_md, a.mt_xl, styles.button]}>
            <ButtonText>
              <Trans>Try Again</Trans>
            </ButtonText>
          </Button>

          <Button
            label="Go to Home"
            onPress={handleGoHome}
            size="large"
            variant="outline"
            color="secondary"
            style={[a.rounded_md, a.mt_md, styles.button]}>
            <ButtonText>
              <Trans>Go to Home</Trans>
            </ButtonText>
          </Button>
        </View>
      </Layout.Content>
    </Layout.Screen>
  )
}

const styles = StyleSheet.create({
  container: {
    minHeight: 400,
  },
  iconContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    minWidth: 200,
  },
})
